//Slick auf Domainseite : Optimierung der Preisdarstellung (Mobil)
$(document).ready(function () {
    var sliderHorizontal = {
        dots: true,
        infinite: true,
        speed: 0,
        arrows: false,
        initialSlide: 0,
        slidesToShow: 1
    };


    $.fn.toSlick = function () {
        var element = {};

        element = $('.slider--mobile');
        if ($('html').hasClass('mobile') && element && element.length > 0) {
            element.slick(sliderHorizontal);
        }
        return this;
    };
    $('.slider--mobile').toSlick();


});
